@if (servicenowVirtualAgentConfig; as config) { @if (config.url) {
<div
  class="servicenow-virtual-agent__chat-dialog"
  [class]="isOpen ? 'open' : 'closed'"
>
  @if (openedOnce) {
  <iframe
    id="sn_va_web_client"
    class="w-100 h-100"
    title="DIRECT Support Chat"
    [src]="config.url | trustResourceUrl"
  >
  </iframe>
  }
</div>
@if ((isConfigStripOpen$ | async) !== true || isOpen) {
<fa-icon
  id="servicenow-virtual-agent__open-close-chat"
  class="servicenow-virtual-agent__open-close-button"
  [icon]="['fas', isOpen ? 'chevron-circle-down' : 'message-lines']"
  (click)="toggleOpenClose()"
>
</fa-icon>
} } }
